const RELOAD_TIMESTAMP_KEY = "chunkReloadAt";

/** Window in which a second failure is treated as a real error, not a stale deploy. */
const RELOAD_COOLDOWN_MS = 10_000;

/**
 * Recovers from a dynamic import that failed because a new deploy replaced the
 * chunk this client asked for: the hashed file is gone and Caddy answers the
 * SPA fallback, so the module never loads.
 *
 * Reloading fetches the fresh index.html with the new hashes. The cooldown
 * keeps a genuinely broken chunk from looping, while still allowing a later
 * deploy in the same session to recover.
 */
export const registerChunkReload = (): void => {
  globalThis.addEventListener("vite:preloadError", (event) => {
    const lastReload = Number(
      sessionStorage.getItem(RELOAD_TIMESTAMP_KEY) ?? 0,
    );

    if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) {
      return;
    }

    // Keeps Vite from rethrowing, since the reload already handles it.
    event.preventDefault();
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
    globalThis.location.reload();
  });
};
